<template>
  <el-dropdown trigger="click" @command="select">
    <span class="badge-dropdown" role="button" tabindex="0">
      {{ badgeText }}
      <i class="tim-icons icon-minimal-down"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="opt in options" :key="'BD' + opt.value" :command="opt.value">
        {{ opt.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';

/**
 * BadgeDropdown
 * Compact pink badge that opens a dropdown of options — for secondary settings
 * displayed inline as "prefix: value" (e.g. "Auto-lock: never", "Collects: full address").
 * With a prefix, the selected label is shown lowercased to read as a sentence.
 *
 * @prop {String|Number} value   selected option value
 * @prop {Array}  options        [{ value, label }]
 * @prop {String} prefix         optional label shown before the value
 * @event input(value)
 */
export default {
  name: 'badge-dropdown',
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      required: true,
      validator: (arr) => arr.every(o => 'value' in o && 'label' in o),
    },
    prefix: {
      type: String,
      default: '',
    },
  },
  computed: {
    selectedLabel() {
      const match = this.options.find(o => o.value === this.value);
      return match ? match.label : '';
    },
    badgeText() {
      if (!this.prefix) return this.selectedLabel;
      const label = this.selectedLabel.charAt(0).toLowerCase() + this.selectedLabel.slice(1);
      return `${this.prefix}: ${label}`;
    },
  },
  methods: {
    select(value) {
      if (value !== this.value) this.$emit('input', value);
    },
  },
};
</script>

<style scoped>
.badge-dropdown {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 8px;
  border-radius: 10px;
  background: rgba(225, 78, 202, 0.12);
  border: 1px solid rgba(225, 78, 202, 0.25);
  color: #e14eca;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 16px;
  white-space: nowrap;
}
.badge-dropdown:hover {
  background: rgba(225, 78, 202, 0.2);
}
.badge-dropdown .tim-icons {
  font-size: 8px;
}
</style>

<style>
.white-content .badge-dropdown {
  background: rgba(225, 78, 202, 0.1);
  border-color: rgba(177, 58, 160, 0.35);
  color: #b13aa0;
}
.white-content .badge-dropdown:hover {
  background: rgba(225, 78, 202, 0.18);
}
</style>
